var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.88 20.94C18.93 21.64 17.68 22 16.19 22H7.80997C7.56997 22 7.32998 21.99 7.09998 21.96L14 15.06L19.88 20.94Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.0001 7.81001V16.19C22.0001 17.68 21.6401 18.93 20.9401 19.88L15.0601 14L21.9601 7.10001C21.9901 7.33001 22.0001 7.57001 22.0001 7.81001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.06 14L20.94 19.88C20.65 20.3 20.3 20.65 19.88 20.94L14 15.06L7.10001 21.96C6.46001 21.92 5.88001 21.79 5.35001 21.59C3.21001 20.81 2 18.91 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.19C18.91 2 20.81 3.21 21.59 5.35C21.79 5.88 21.92 6.46 21.96 7.1L15.06 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.06 14L20.94 19.88C20.65 20.3 20.3 20.65 19.88 20.94L14 15.06L7.09998 21.96C6.45998 21.92 5.87998 21.79 5.34998 21.59L5.73996 21.2L21.59 5.35001C21.79 5.88001 21.92 6.46001 21.96 7.10001L15.06 14Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 7.93C11.86 6.28 10.4001 5.54 9.12005 5.53C7.84005 5.53 6.38006 6.27 6.00006 7.92C5.58006 9.75 6.70005 11.28 7.71005 12.24C8.11005 12.62 8.61005 12.8 9.12005 12.8C9.63005 12.8 10.1301 12.61 10.5301 12.24C11.5401 11.28 12.66 9.75 12.24 7.93ZM9.15005 9.49C8.60005 9.49 8.15005 9.04 8.15005 8.49C8.15005 7.94 8.59005 7.49 9.15005 7.49H9.16006C9.71006 7.49 10.1601 7.94 10.1601 8.49C10.1601 9.04 9.70005 9.49 9.15005 9.49Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fb369655062eb9e1fe69d3289396e656.svg";
export { ForwardRef as ReactComponent };